


















// import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { mixins } from 'vue-class-component';
import TagHelper from '@/mixins/TagHelper';
import clone from '@/lib/clone';

@Component
export default class Tags extends mixins(TagHelper) {
  @Prop({default: []}) readonly value!: Tag[];

  get tagList() {
    return this.$store.state.tagList
  }

  created() {
    this.$store.commit('fetchTags')
  }

  toggle(tag: Tag) {
    const tags = clone(this.value)
    const index = tags.map(item => item.id).indexOf(tag.id);
    if (index >= 0) {
      tags.splice(index, 1);
    } else {
      tags.push(tag);
    }
    this.$emit('update:value', tags)
  }
}
